import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { useAppSelector } from '../../hooks';
import { adaptAccountProviderUserHealthCheckFromListResponse, TAccountProviderUserHealthCheckList, TAccountProviderUserHealthCheckListResponse } from '../../types';
import { BACKEND_ACCOUNT_PROVIDER_USER_HEALTH_CHECK } from '../../backend-paths';


export const accountProviderUserHealthCheckGetApi = createAsyncThunk(
	BACKEND_ACCOUNT_PROVIDER_USER_HEALTH_CHECK,
	(payload: undefined, thunkApi) => {
		return HttpService.get<TAccountProviderUserHealthCheckListResponse>(BACKEND_ACCOUNT_PROVIDER_USER_HEALTH_CHECK).then(result => {
			return adaptAccountProviderUserHealthCheckFromListResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

type TInitialState = {
	isLoading: boolean;
	list: TAccountProviderUserHealthCheckList;
	error?: HttpError;
};

const initialState: TInitialState = {
	isLoading: false,
	list: {
		items: [],
		count: 0,
	},
	error: undefined,
};

export const accountProviderUserHealthCheckSlice = createSlice({
	name: 'accountProviderUserHealthCheckSlice',
	initialState,
	reducers: {
		clearAccountProviderUserHealthCheck(state) {
			return { ...initialState, list: state.list };
		},
	},

	extraReducers: {
		[accountProviderUserHealthCheckGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[accountProviderUserHealthCheckGetApi.fulfilled.type]: (state, action: PayloadAction<TAccountProviderUserHealthCheckList>) => {
			state.isLoading = false;
			state.list = action.payload;
			state.error = undefined;
		},

		[accountProviderUserHealthCheckGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useAccountProviderUserHealthCheckSelector = () => useAppSelector(state => state[accountProviderUserHealthCheckSlice.name]);

export const { clearAccountProviderUserHealthCheck } = accountProviderUserHealthCheckSlice.actions;
